import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { paths } from '../../common/constants/pathVariables.js';
import { employeeOmaElisaMsg, loginMsg, omaElisaForCompaniesCapitalMsg, t } from '../../common/i18n/index.js';
import { useAuth } from '../../public/site/AuthProvider.js';

import './ElisaIdLogin.scss';

export const ElisaIdLogin = () => {
  const { prepareElisaIdLogin } = useAuth();
  return (
    <div
      id="of-self-service-parent"
      className={`of-self-service__path ${dsClass.BACKGROUND_COLOR_NEUTRAL_200} ${dsClass.MARGIN_0}`}
    >
      <div className="ds-container">
        <div className="of-login-elisa-id">
          <CL.Grid className={`of-login-elisa-id__grid ${dsClass.DISPLAY_FLEX} ${dsClass.PADDING_6}`}>
            <CL.GridRow>
              <CL.GridCol colWidthXS={3} colWidthS={5} colWidthM={5} colWidthL={7}>
                <div className={`of-login-elisa-id__header ${dsClass.DISPLAY_FLEX}`}>
                  <h1 className={`${dsClass.H1} ${dsClass.MARGIN_0}`}>{t.LOUS(omaElisaForCompaniesCapitalMsg)}</h1>
                  <p>
                    {t.HQ3V('Using OmaElisa for Companies requires an Elisa ID.')}{' '}
                    {t.HJ9V(
                      'A business account can only be created by a person who has the legal right to sign on behalf of the company.'
                    )}
                  </p>
                  <div className={`of-login-elisa-id__buttons ${dsClass.DISPLAY_FLEX} ${dsClass.MARGIN_0}`}>
                    <CL.Button
                      color="primary"
                      id="login"
                      size="l"
                      onClick={() => prepareElisaIdLogin({ isEmployee: false })}
                    >
                      {t.Z16I(loginMsg)}
                    </CL.Button>
                    <CL.Button
                      color="secondary"
                      size="l"
                      onClick={() => prepareElisaIdLogin({ noContextClient: true, register: true })}
                    >
                      {t.AMMX('Create a business account')}
                    </CL.Button>
                  </div>
                </div>
              </CL.GridCol>
              <CL.GridCol colWidthXS={1} colWidthS={1} colWidthM={1} colWidthL={5}>
                <div className="of-login-elisa-id__illustration" />
              </CL.GridCol>
            </CL.GridRow>
            <CL.GridRow>
              <CL.GridCol colWidthL={12}>
                <div className={`of-login-elisa-id__info ${dsClass.DISPLAY_FLEX} ${dsClass.PADDING_4}`}>
                  <h3 className={dsClass.MARGIN_0}>{t.LOUS(omaElisaForCompaniesCapitalMsg)}</h3>
                  <div>
                    {t.PH37(
                      `In OmaElisa for Companies, you can manage your company's devices, subscriptions, and many additional services with no service fees. Pay invoices, view billing history, edit billing details, and download invoice copies. If needed, you can chat directly with our customer service.`
                    )}
                  </div>
                </div>
              </CL.GridCol>
            </CL.GridRow>
            <CL.GridRow>
              <CL.GridCol colWidthL={12}>
                <div className={`of-login-elisa-id__footer ${dsClass.DISPLAY_FLEX}`}>
                  <h4 className={`${dsClass.H4} ${dsClass.MARGIN_0}`}>{t.BJ8A('Other self service channels')}</h4>
                  <div className={`of-login-elisa-id__footer__links ${dsClass.DISPLAY_FLEX}`}>
                    <CL.Link
                      linkStyle="link"
                      className="of-login-elisa-id__footer__link"
                      linkHref={paths.EMPLOYEE_HOME}
                    >
                      <svg className="of-login-elisa-id__footer__link__home-office"></svg>
                      <span>{t.UBBK(employeeOmaElisaMsg)}</span>
                    </CL.Link>
                    <CL.Link
                      linkStyle="link"
                      className="of-login-elisa-id__footer__link"
                      linkHref="https://verkkoasiointi.elisa.fi/kirjautuminen"
                    >
                      <svg className="of-login-elisa-id__footer__link__self-service"></svg>
                      <span>{t.NI69('OmaElisa for consumer')}</span>
                    </CL.Link>
                    <CL.Link
                      linkStyle="link"
                      className="of-login-elisa-id__footer__link"
                      linkHref="https://verkkoasiointi.elisa.fi/kirjautuminen"
                    >
                      <svg className="of-login-elisa-id__footer__link__saunalahti-logo"></svg>
                      <span className="of-login-elisa-id__footer__link__saunalahti-text">
                        <span>{t.F8VB(`Corporate customer of Elisa's consumer subscriptions`)}</span>
                        <span>{t.NAKQ('(former Saunalahti company customer)')}</span>
                      </span>
                    </CL.Link>
                  </div>
                </div>
              </CL.GridCol>
            </CL.GridRow>
          </CL.Grid>
        </div>
      </div>
    </div>
  );
};
